import axios from 'axios';

export const defaultState = {
  signings: [],
};

export const mutations = {
  SET_BRIDGE_SIGNING_DATA(signingState, data) {
    signingState.signings = data;
  },
};

export const getters = {
  getBridgeSignings: signingState => signingState.signins,
};

export const actions = {

  fetchBridgeSignings({ commit }) {
    return axios.get(`${window.BASE_API.BRIDGE_SIGNING}`)
      .then(({ data }) => {
        commit('SET_BRIDGE_SIGNING_DATA', data.allBridgeSignings);

        return data.allBridgeSignings;
      })
      .catch((error) => {
        commit('SET_BRIDGE_SIGNING_DATA', []);

        return Promise.reject(error);
      });
  },

  createBridgeSigning({ dispatch }, payload) {
    return axios.post(`${window.BASE_API.BRIDGE_SIGNING}`, payload)
      .then((data) => {
        dispatch('fetchBridgeSignings');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },

  updateBridgeSigning({ dispatch }, payload) {
    const { id } = payload;
    delete payload.id;

    return axios.put(`${window.BASE_API.BRIDGE_SIGNING}/${id}`, payload)
      .then((data) => {
        dispatch('fetchBridgeSignings');

        return data;
      }).catch((err) => {
        const error = err.response && err.response.data ? err.response.data : err;

        return Promise.reject(error);
      });
  },
};

const bridgeSigningStore = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default bridgeSigningStore;



// WEBPACK FOOTER //
// ./src/store/bridgeSigning/bridgeSigningStore.js